import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { DynamicTicketResponse } from '@/types/apps/dynamic-ticket.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface DynamicTicketGraphQLServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type DynamicTicketListResponse = GqlListResponse<DynamicTicketResponse>;

export class DynamicTicketGraphQLService
    extends BaseService
    implements DynamicTicketGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'ticketTemplate';
    }

    public getFields(): Record<string, any> {
        return {
            id: true,
            code: true,
            name: true,
            lastExecutedAt: true,
            executionCount: true,
            nextExecutionAt: true,
            assignee: {
                id: true,
                fullname: true,
            },
        };
    }

    public async index(query: string): Promise<DynamicTicketListResponse> {
        return this.fetchGqlList(query, this.getEntityName()).then(res => {
            return {
                ...res,
                items: res.items.map((item: DynamicTicketResponse) => ({
                    ...item,
                    customName: `${item.code} - ${item.name}`,
                })),
            };
        });
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('dynamicTicket', {
            userId: this.getQueryById(),
        });
    }
}
